import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import genererMaterielAngleVision from '@/services/parametrage/generation/genererParametrageGenerique';
import { create } from '@/api/materielAngleVision/index';

export default async function getAngleVisionMateriel(angleVisions) {
  await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.materielAngleVision]);
  const listeAngleParam = store.getters['parametres/parametre'](PARAMETRES_KEYS.materielAngleVision);
  let reqAngleVision = [];
  [...new Set(angleVisions)].forEach((angle) => {
    if (!angle?.trim()) return;
    const isInParam = listeAngleParam.find((f) => f.libelle.toLowerCase().trim()
      === angle.toLowerCase().trim());
    if (!isInParam) {
      const angleVision = genererMaterielAngleVision();
      angleVision.libelle = angle;
      reqAngleVision.push(create(angleVision));
    }
  });
  if (reqAngleVision.length) {
    await Promise.all(reqAngleVision);
    reqAngleVision = [];
  }
}
